// Mock data para la landing page de Kari Rojas

export const testimonials = [
  {
    id: 1,
    name: "María González",
    role: "Emprendedora",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
    text: "Gracias a Kari aprendí a organizar mis finanzas y ahora puedo viajar sin culpa. ¡Transformó mi vida financiera completamente!",
    rating: 5
  },
  {
    id: 2,
    name: "Laura Martínez",
    role: "Profesional Independiente",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
    text: "El curso de Kari me ayudó a salir de deudas y crear mi primer fondo de emergencia. Ahora tengo paz financiera.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Rodríguez",
    role: "Ejecutiva",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400",
    text: "Su libro cambió mi mentalidad sobre el dinero. Ahora entiendo cómo hacer que mi dinero trabaje para mí.",
    rating: 5
  }
];

export const mediaContent = [
  {
    id: 1,
    title: "Conferencia: Libertad Financiera Femenina",
    type: "video",
    thumbnail: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?w=600",
    description: "Conferencia magistral sobre empoderamiento financiero",
    duration: "45 min"
  },
  {
    id: 2,
    title: "Entrevista en Radio Nacional",
    type: "video",
    thumbnail: "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=600",
    description: "Hablando sobre finanzas personales para mujeres",
    duration: "30 min"
  },
  {
    id: 3,
    title: "Programa en Vivo: Presupuesto Consciente",
    type: "video",
    thumbnail: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600",
    description: "Cómo crear un presupuesto que funcione",
    duration: "60 min"
  }
];

export const courseFeatures = [
  {
    id: 1,
    title: "Mentalidad financiera",
    description: "Transforma tu relación con el dinero, cambia tus hábitos y reprograma tus patrones financieros para crear estabilidad y crecimiento."
  },
  {
    id: 2,
    title: "Metas financieras",
    description: "Convierte tus sueños financieros en objetivos claros, medibles y alcanzables con estrategias que te lleven a resultados reales."
  },
  {
    id: 3,
    title: "Gastos inteligentes",
    description: "Aprende a controlar tus gastos, eliminar fugas de dinero y tomar decisiones conscientes que te permitan ahorrar e invertir cada mes."
  },
  {
    id: 4,
    title: "Elimina tus deudas",
    description: "Aplica estrategias efectivas para salir de deudas y construir un sistema que te mantenga libre de ellas para siempre."
  },
  {
    id: 5,
    title: "Lenguaje del dinero",
    description: "Domina los conceptos financieros clave y pierde el miedo a invertir con claridad y seguridad."
  },
  {
    id: 6,
    title: "Portafolio de inversiones",
    description: "Invierte con inteligencia emocional y financiera para construir patrimonio sólido a largo plazo."
  }
];

// Preguntas del Diagnóstico Financiero - Sección 1: Hábitos Financieros (Escala 0-10)
export const diagnosticQuestionsScale = [
  {
    id: 1,
    section: 1,
    question: "¿Llevas un registro claro de tus ingresos y gastos cada mes?",
    type: "scale"
  },
  {
    id: 2,
    section: 1,
    question: "¿Tienes un presupuesto mensual que respetas?",
    type: "scale"
  },
  {
    id: 3,
    section: 1,
    question: "¿Ahorras una parte de tus ingresos cada mes, aunque sea un 10% mínimo?",
    type: "scale"
  },
  {
    id: 4,
    section: 1,
    question: "¿Tienes un fondo de emergencia que cubre mínimo 3 - 6 meses de gastos?",
    type: "scale"
  },
  {
    id: 5,
    section: 1,
    question: "¿Tus deudas están bajo control, representan menos del 30% de tus ingresos?",
    type: "scale"
  },
  {
    id: 6,
    section: 1,
    question: "¿Tienes metas financieras específicas para los próximos 12 meses?",
    type: "scale"
  },
  {
    id: 7,
    section: 1,
    question: "¿Conoces tu perfil de inversionista?",
    type: "scale"
  },
  {
    id: 8,
    section: 1,
    question: "¿Conoces el lenguaje básico del dinero (interés compuesto, inflación, ROI, activos, pasivos, patrimonio, etc.)?",
    type: "scale"
  },
  {
    id: 9,
    section: 1,
    question: "¿Estás invirtiendo actualmente en algo que haga crecer tu dinero?",
    type: "scale"
  },
  {
    id: 10,
    section: 1,
    question: "¿Tienes un portafolio de inversión diversificando niveles de riesgos?",
    type: "scale"
  }
];

// Preguntas del Diagnóstico Financiero - Sección 2: Patrones Financieros (Reflexión)
export const diagnosticQuestionsReflection = [
  {
    id: 11,
    section: 2,
    question: "¿Mientras más ganas, más gastas? ¿Por qué?",
    type: "text"
  },
  {
    id: 12,
    section: 2,
    question: "¿Generas dinero solo cuando trabajas? ¿Por qué?",
    type: "text"
  },
  {
    id: 13,
    section: 2,
    question: "¿Dependes de una sola fuente de Ingresos? ¿Por qué?",
    type: "text"
  },
  {
    id: 14,
    section: 2,
    question: "¿Sientes que trabajas por dinero o que el dinero trabaja para ti? ¿Por qué?",
    type: "text"
  },
  {
    id: 15,
    section: 2,
    question: "¿Consideras que haces más compras emocionales de las que deberías?",
    type: "text"
  },
  {
    id: 16,
    section: 2,
    question: "¿Confías en tu capacidad para generar, administrar y multiplicar el dinero?",
    type: "text"
  },
  {
    id: 17,
    section: 2,
    question: "¿Tienes alguna creencia financiera negativa? Ejemplo: 'el dinero es malo', 'no soy buena con el dinero', '¿hay que trabajar duro para generar dinero?'",
    type: "text"
  },
  {
    id: 18,
    section: 2,
    question: "¿Eres financieramente independiente?",
    type: "text"
  },
  {
    id: 19,
    section: 2,
    question: "Si perdieras tu principal fuente de ingresos, ¿Cuántos meses podrías seguir sosteniendo tu mismo estilo de vida?",
    type: "text"
  },
  {
    id: 20,
    section: 2,
    question: "¿Estás comprometida con lograr tu libertad financiera, más allá de tus excusas y miedos? ¿O aún quieres postergarla más tiempo?",
    type: "text"
  }
];

export const bookHighlights = [
  "Guía práctica para vivir en paz financiera",
  "Logra tus metas sin depender de nadie",
  "Ejercicios y herramientas aplicables",
  "Basado en casos reales de transformación"
];
